var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content pb-0" },
    [
      _c(
        "Titlebar",
        {
          attrs: {
            incrustation: "fa-bullhorn",
            backPath: { name: "RemoteMonitoringList" },
          },
        },
        [
          _c("h1", [
            _vm._v(
              _vm._s(
                _vm.viewState === "SUCCESS" && !!_vm.rmData.current
                  ? _vm.rmData.current.name
                  : _vm.$t("remoteMonitoring.titles.manager")
              )
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "UiCard",
        [
          _vm.viewState === "INITIAL" || _vm.viewState === "LOADING"
            ? _c("UiSpinner")
            : _vm._e(),
          _vm._v(" "),
          _vm.viewState === "SUCCESS" && _vm.canBrowse
            ? _c(
                "section",
                [
                  _vm.infoMessage
                    ? _c(
                        "div",
                        {
                          staticClass: "alert text-md mb-4",
                          class: _vm.infoMessage.className,
                        },
                        [
                          _c("h5", {
                            staticClass: "font-weight-bold",
                            domProps: {
                              innerHTML: _vm._s(_vm.infoMessage.title),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "mb-2" },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("global.saved_last")) +
                                  " : \n          "
                              ),
                              _c("UiRelativeDate", {
                                attrs: {
                                  date: _vm.rmData.current.updated_at.date,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "mb-0",
                            domProps: {
                              innerHTML: _vm._s(_vm.infoMessage.body),
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rmData.current.status === "verified" ||
                  _vm.rmData.current.status === "refused"
                    ? _c("MonitoringDisplay", {
                        attrs: { rmData: _vm.rmData.current },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rmData.current.status === "waiting"
                    ? _c(
                        "UiTabs",
                        {
                          staticClass: "full-height mt-1",
                          staticStyle: {
                            display: "grid",
                            "grid-template-rows": "min-content 1fr",
                          },
                          attrs: {
                            "content-class": "full-height overflow-auto py-4",
                          },
                        },
                        [
                          _c(
                            "UiTab",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "remoteMonitoring.display.tab_current"
                                ),
                              },
                            },
                            [
                              _c("MonitoringDisplay", {
                                attrs: { rmData: _vm.rmData.current },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "UiTab",
                            {
                              attrs: {
                                title: _vm.$t(
                                  "remoteMonitoring.display.tab_last"
                                ),
                              },
                            },
                            [
                              _c("MonitoringDisplay", {
                                attrs: { rmData: _vm.rmData.last },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.viewState === "SUCCESS" && !_vm.canBrowse
            ? _c("p", [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("module.forbidden")) + "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "toolbar-ghost" }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "d-flex align-items-center justify-content-end gap-3",
            },
            [
              _vm.viewState === "SUCCESS"
                ? _c(
                    "UiButton2",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can",
                          value: "beepiz-edit-remotemonitoring",
                          expression: "'beepiz-edit-remotemonitoring'",
                        },
                      ],
                      staticClass: "btn-danger btn-lg",
                      attrs: {
                        disabled: _vm.rmData.current.status === "waiting",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleDelete()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.delete")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.viewState === "SUCCESS"
                ? _c(
                    "UiButton2",
                    {
                      directives: [
                        {
                          name: "can",
                          rawName: "v-can",
                          value: "beepiz-edit-remotemonitoring",
                          expression: "'beepiz-edit-remotemonitoring'",
                        },
                      ],
                      staticClass: "btn-brand btn-lg",
                      attrs: {
                        disabled: _vm.rmData.current.status === "waiting",
                      },
                      nativeOn: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleEdit()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("global.edit")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }